let sessionExpiryHandled = false;

export function isSessionExpiryHandled(): boolean {
  return sessionExpiryHandled;
}

export function markSessionExpiryHandled(): void {
  sessionExpiryHandled = true;
}

export function resetSessionExpiryHandling(): void {
  sessionExpiryHandled = false;
}
